export const unregisterServiceWorker = (): void => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then((registration) => {
      registration.unregister();
    });
  }
};

export const registerServiceWorker = (): void => {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .register("/firebase-messaging-sw.js")
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log("Service worker registration failed, error:", err);
      });
  }
};
